import React from "react";
import { AppSettings } from "@design-system";
import { Spin } from "antd";
import { UPDATE_SETTINGS } from "../../../graphql/mutation";
import { useMutation, useSettings } from "../../../hooks";
import { FIND_LATEST_SETTINGS_QUERY } from "../../../graphql/query";

export const AppSettingsContainer = () => {
  const { loading, settings } = useSettings();

  const [updateSettings] = useMutation(UPDATE_SETTINGS, {
    update(cache, { data }) {
      const updateSettings = data?.updateSettings;
      if (updateSettings) {
        cache.writeQuery({
          query: FIND_LATEST_SETTINGS_QUERY,
          data: {
            findLatestSettings: updateSettings,
          },
        });
      }
    },
  });

  return (
    <>
      {loading ? (
        <Spin size="large" />
      ) : (
        <AppSettings
          key={settings.id}
          settings={settings}
          onUpdateSettings={async (settingsData) => {
            await updateSettings({
              variables: {
                id: settings.id,
                data: {
                  enableAi: { set: settingsData.enableAi },
                  enableTechPricing: { set: settingsData.enableTechPricing },
                  systemFont: { set: settingsData.systemFont },
                },
              },
              update: (cache, { data }) => {
                const updateSettings = data?.updateSettings;
                console.log("updateSettings", updateSettings);
                if (updateSettings) {
                  cache.writeQuery({
                    query: FIND_LATEST_SETTINGS_QUERY,
                    data: { findLatestSettings: updateSettings },
                  });
                }
              },
            });
          }}
        />
      )}
    </>
  );
};
